

























































import {Vue, Component, Ref, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ImportZonesItem} from "@/store/tarification/types";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import Swal from "sweetalert2";
import {BlacklistItem} from "@/store/settings/blacklists/types";
import {readFileAsBinary} from "@/utils/download-helper"
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @PropSync('show') is_show!: boolean;
  @PropSync('blacklist_id') blacklistId!: number;
  @Ref('validator') validator: any;
  @Action("importBlackListContacts") actionImport: any;
  @Action("getBlackListItem") actionGetBlackListItem: any;
  @Action("actionLog") actionLog: any;
  @Getter delimiterList:any;

  private importRequest: ImportZonesItem = {
    name: undefined,
    file: undefined,
    delimiter: ',',
    uniqueness_policy: 0
  };
  private contacts_uniqueness: number|undefined = 0;
  private logObject: ActionLog = {};

  created() {
    this.actionGetBlackListItem(this.blacklistId).then((data: BlacklistItem)=>{
      this.contacts_uniqueness = data.check_duplicates_policy
    });
  }

  onFileUpload (evt: any) {
    this.importRequest.file = evt[0]
  }

  async importZones():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return;
    }
    try {
      const fileString = await readFileAsBinary(this.importRequest.file)
      let object = {
        id: this.blacklistId,
        item: {
          name: this.importRequest.name,
          file: btoa(fileString),
          delimeter: this.importRequest.delimiter === 'space' ?  ' ' : this.importRequest.delimiter,
          uniqueness_policy: this.importRequest.uniqueness_policy
        }
      }
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Import",
        action_status: "success",
        object_type: "Contact",
        addititional_info: getTranslatedParams(object)
      }
      let response: any = await this.actionImport(object);
      await this.actionLog(this.logObject);
      await Swal.fire({
        type: 'success',
        title: <string> this.$t('import_success'),
        confirmButtonClass: "md-button md-success",
        html: `Загружено записей: ${response?.data?.recipients_count ?? 0}`,
        showConfirmButton: true
      });
    } catch (error) {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(error);
    }
  }
}
